// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '../stylesheets/application'

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("bootstrap/dist/js/bootstrap.bundle")
require("../document/flashes")
require("../document/qr-code")
require("../document/decrypt")
require("../document/date-picker")
require("../document/select")
require("../document/forms")
require("../document/stripe")
require("../document/cart")
require("../document/enable-cookie")
require("../document/qr-code-data")
require("../document/vcard-qr-preview")


// expose jquery
const jQuery = require('jquery')

// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.jQuery = jQuery
window.jQuery = jQuery

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
